import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  Maps,
  MapsComponent,
  MapsTooltip,
  ISelectionEventArgs,
  Selection,
  Highlight,
  MapsModule,
  MapsTooltipService,
  DataLabelService,
} from '@syncfusion/ej2-angular-maps';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { italyMap } from '../../../../../../shared/italy-regions';
import { NtPotentialRegionInterface } from '../../../../../../shared/interfaces/nt-potential-region.interface';
import { ModalInclusionPerRegComponent } from '../modal-inclusion-per-reg/modal-inclusion-per-reg.component';
import { CommonModule } from '@angular/common';

Maps.Inject(MapsTooltip, Selection, Highlight);

@Component({
  selector: 'app-heatmap-inclusion-process',
  imports: [MapsModule, ModalInclusionPerRegComponent, CommonModule],
  providers: [MapsTooltipService, DataLabelService],
  templateUrl: './heatmap-inclusion-process.component.html',
  styleUrl: './heatmap-inclusion-process.component.css',
})
export class HeatmapInclusionProcessComponent implements OnChanges {
  @ViewChild(MapsComponent) public maps?: MapsComponent;

  public mapWidth: string = '98%';
  public mapHeight: string = '98%';

  public medicineId = 0;
  public countryId = 1;
  public companyId = 0;
  public regionId = 0;
  public regionName = '';
  public regionPercentage = '';

  public isModalInclusioneActive: boolean = false;

  public layers?: object[];

  @Input() heatmapColorStatus: 'Red' | 'White' = 'Red';

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.layers = [
      {
        shapeData: italyMap,
      },
    ];

    this.medicineId = sessionStorage.getItem('medicineId')
      ? Number(sessionStorage.getItem('medicineId'))
      : 0;
    this.countryId = sessionStorage.getItem('countryId')
      ? Number(sessionStorage.getItem('countryId'))
      : 1;
    this.companyId = sessionStorage.getItem('companyId')
      ? Number(sessionStorage.getItem('companyId'))
      : 0;
    this.loadData();

    /*
        this.dataService.medicineUpdated$.subscribe((medicineId: number) => {
          if (medicineId !== 0) {
            this.medicineId = medicineId;
            this.loadData();  // Ricarica i dati quando cambia il medicineId
          }
        });
    */
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['heatmapColorStatus'] &&
      !changes['heatmapColorStatus'].firstChange
    ) {
      this.loadData();

      setTimeout(() => {
        if (this.maps) {
          this.maps.refresh();
        }
      }, 100);
    }
  }

  loadData() {
    //this.dataService.getRegioniHeatmapData(this.medicineId, this.countryId).subscribe((data: NtPotentialRegionInterface[]) => {
    this.dataService
      .getHeatmapInfo(this.companyId, this.medicineId, this.countryId)
      .subscribe((data: NtPotentialRegionInterface[]) => {
        if (data && data.length > 0) {
          const regioniHeatmapData = data.map((item) => {
            // Parse percentage and default to 0 if undefined
            let percentage =
              item.percentage !== undefined
                ? parseFloat(item.percentage).toFixed(2)
                : 0;

            /*  good to test the max celing in abruzzo giving a value higher than 100.00
          if (Number(item.regionId) === 14) {
            percentage = '105.00';
          }
            */

            // MAX CELING AT 100%

            // Convert percentage to number (string → parseFloat, number → keep as is)
            const tempPercentage =
              typeof percentage === 'string'
                ? parseFloat(percentage)
                : percentage;
            if (tempPercentage >= 100.0) {
              percentage = '100.00';
            }

            /*let color = ''; // Dynamic color for regions 4 and 5

          if (Number(item.regionId) === 4 || Number(item.regionId) === 5) {
            const region4 = data.find(i => Number(i.regionId) === 4);
            const region5 = data.find(i => Number(i.regionId) === 5);

            if (region4 && region5) {
              const percentage4 = parseFloat(region4.percentage || '0');
              const percentage5 = parseFloat(region5.percentage || '0');

              // Logic for combined coloring
              if (percentage4 === 100 && percentage5 === 100) {
                color = '#19FD06'; // Green for both 100%
              } else if (percentage4 === 0 && percentage5 === 0) {
                color = '#ff6963'; // Red for both 0%
              } else {
                // Calculate average percentage of prov. autonoma Bolzano and Trento
                const averagePercentage = (percentage4 + percentage5) / 2;

                if (averagePercentage >= 0 && averagePercentage <= 1) {
                  color = '#ff6963';
                } else if (averagePercentage <= 20) {
                  color = '#ffa369';
                } else if (averagePercentage <= 40) {
                  color = '#FFC461';
                } else if (averagePercentage <= 60) {
                  color = '#FFDA4A';
                } else if (averagePercentage <= 80) {
                  color = '#F5EC38';
                } else if (averagePercentage <= 99) {
                  color = '#87F520';
                } else if (averagePercentage === 100) {
                  color = '#19FD06';
                }
              }

              // Return dynamically colored regions
              return {
                ...item,
                tooltipText: `${region4.regionName}: ${region4.percentage}% <br>${region5.regionName}: ${region5.percentage}%`,
                color
              };
            }
          }*/

            // Default logic for other regions
            return {
              ...item,
              tooltipText: `${
                item.regionName === 'Prov. Aut. di Bolzano'
                  ? 'PA di Bolzano'
                  : item.regionName === 'Prov. Aut. di Trento'
                    ? 'PA di Trento'
                    : item.regionName
              }: <br> ${percentage}%`,
              percentage, // Use percentage for default colorMapping
              color: '', // Leave blank for colorMapping regions
            };
          });

          this.layers = [
            {
              shapeData: italyMap,
              shapePropertyPath: 'id',
              shapeDataPath: 'regionId',
              dataSource: regioniHeatmapData,
              tooltipSettings: {
                visible: true,
                valuePath: 'tooltipText',
                textStyle: {
                  size: '10px',
                },
              },
              highlightSettings: {
                enable: false,
                fill: '#00CEBC',
              },
              selectionSettings: {
                enable: true,
                fill: '',
                opacity: 1,
                border: {
                  color:
                    this.heatmapColorStatus === 'White' ? '#162456' : '#FFFFFF',
                  width: this.heatmapColorStatus === 'White' ? 0.7 : 0.4,
                },
              },
              shapeSettings: {
                border: {
                  color:
                    this.heatmapColorStatus === 'White' ? '#162456' : '#FFFFFF',
                  width: this.heatmapColorStatus === 'White' ? 0.7 : 0.4,
                },
                borderWidth: this.heatmapColorStatus === 'White' ? 0.7 : 4,
                colorValuePath: 'percentage', // Default regions use this
                fill: (properties: any) => {
                  const regionData = regioniHeatmapData.find(
                    (region: any) => region.regionId === properties.id,
                  );
                  return regionData && regionData.color
                    ? regionData.color
                    : null; // Use dynamic color for regions 4 and 5
                },
                colorMapping: this.getColorMapping(),
              },
            },
          ];

          setTimeout(() => {
            if (this.maps) {
              this.maps.refresh();
            }
          }, 50);
        }
      });
  }

  public itemSelection = (args: ISelectionEventArgs) => {
    if (args.shapeData !== isNullOrUndefined) {
      this.isModalInclusioneActive = true;
      this.regionId = Number(
        (args.data as NtPotentialRegionInterface).regionId,
      );
      this.regionName = (args.data as NtPotentialRegionInterface).regionName;
      this.regionPercentage = (args.data as any).percentage ?? '0.00';
    }
  };

  showModalInclusione(value: boolean) {
    this.isModalInclusioneActive = value;
  }

  private getColorMapping(): any[] {
    if (this.heatmapColorStatus === 'Red') {
      return [
        { from: 0, to: 0, color: '#c10007' },
        { from: 0.01, to: 8.33, color: '#dd3a3f' },
        { from: 8.34, to: 16.66, color: '#e95b43' },
        { from: 16.67, to: 24.99, color: '#f47938' },
        { from: 25.0, to: 33.32, color: '#fba63a' },
        { from: 33.33, to: 41.65, color: '#ffd04c' },
        { from: 41.66, to: 49.98, color: '#ffe84a' },
        { from: 49.99, to: 58.31, color: '#e4f042' },
        { from: 58.32, to: 66.64, color: '#c5e73c' },
        { from: 66.65, to: 74.97, color: '#9fdd38' },
        { from: 74.98, to: 83.3, color: '#7cca33' },
        { from: 83.31, to: 91.63, color: '#51b42f' },
        { from: 91.64, to: 94.99, color: '#2e9c2b' },
        { from: 95.00, to: 98.99, color: '#27982d' },
        { from: 99.00, to: 100, color: '#008236' },
      ];
    } else {
      return [
        { from: 0, to: 0, color: '#ffffff' },
        { from: 0.01, to: 8.33, color: '#f8f8f8' },
        { from: 8.34, to: 16.66, color: '#eaeaea' },
        { from: 16.67, to: 24.99, color: '#e0e0e0' },
        { from: 25.0, to: 33.32, color: '#d0d0b3' },
        { from: 33.33, to: 41.65, color: '#d0d09c' },
        { from: 41.66, to: 49.98, color: '#c4c44d' },
        { from: 49.99, to: 58.31, color: '#9fbf4d' },
        { from: 58.32, to: 66.64, color: '#7fb34d' },
        { from: 66.65, to: 74.97, color: '#60a34d' },
        { from: 74.98, to: 83.3, color: '#449E51' },
        { from: 83.31, to: 91.63, color: '#3C9841' },
        { from: 91.64, to: 94.99, color: '#43a047' },
        { from: 95.00, to: 98.99, color: '#399c44' },
        { from: 99.00, to: 100, color: '#008236' },
      ];
    }
  }

  getGradientBackground(): string {
    if (this.heatmapColorStatus === 'Red') {
      return 'linear-gradient(90deg, #c10007 0%, #dd3a3f 8.33%, #e95b43 16.66%, #f47938 24.99%, #fba63a 33.32%, #ffd04c 41.65%, #ffe84a 49.98%, #e4f042 58.31%, #c5e73c 66.64%, #9fdd38 74.97%, #7cca33 83.30%, #51b42f 91.63%, #2e9c2b 99.99%, #008236 100%)';
    } else {
      return 'linear-gradient(90deg, #ffffff 0%, #f8f8f8 8.33%, #eaeaea 16.66%, #e0e0e0 24.99%, #d0d0b3 33.32%, #d0d09c 41.65%, #c4c44d 49.98%, #9fbf4d 58.31%, #7fb34d 66.64%, #60a34d 74.97%, #40934d 83.30%, #2e7d32 91.63%, #1b5e20 99.99%, #008236 100%)';
    }
  }
}
